import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CalendarFill = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect x="1" y="1" width="14" height="14" rx="2" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 0C4.77614 0 5 0.223858 5 0.5V1H11V0.5C11 0.223858 11.2239 0 11.5 0C11.7761 0 12 0.223858 12 0.5V1H13C14.1046 1 15 1.89543 15 3V5.5V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V5.5V3C1 1.89543 1.89543 1 3 1H4V0.5C4 0.223858 4.22386 0 4.5 0ZM11 2V3C11 3.27614 11.2239 3.5 11.5 3.5C11.7761 3.5 12 3.27614 12 3V2H13C13.5523 2 14 2.44772 14 3V5L2 5V3C2 2.44772 2.44772 2 3 2H4V3C4 3.27614 4.22386 3.5 4.5 3.5C4.77614 3.5 5 3.27614 5 3V2H11ZM2 6L14 6V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V6ZM5 8V9H4V8H5ZM12 9V8H11V9H12ZM7.5 8H8.5V9H7.5V8ZM5 12V11H4V12H5ZM12 11V12H11V11H12ZM8.5 11H7.5V12H8.5V11Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default CalendarFill
